import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, STORAGE_KEY } from "@/i18n";
import { cn } from "@/lib/utils";

export function LanguageSwitcher({ className }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

  const handleChange = (lng) => {
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem(STORAGE_KEY, lng);
    } catch (_) {
      // ignore quota errors
    }
  };

  return (
    <div
      role="group"
      aria-label="Language"
      data-testid="language-switcher"
      className={cn(
        "inline-flex items-center gap-0.5 rounded-lg border border-slate-200 bg-white p-1 shadow-sm",
        className
      )}
    >
      {SUPPORTED_LANGUAGES.map((lng) => {
        const active = current === lng;
        return (
          <button
            key={lng}
            type="button"
            data-testid={`lang-${lng}`}
            onClick={() => handleChange(lng)}
            className={cn(
              "rounded-md px-2.5 py-1 text-xs font-medium uppercase tracking-wider transition-all",
              active
                ? "bg-slate-900 text-white shadow-sm"
                : "text-slate-500 hover:text-slate-900"
            )}
          >
            {lng}
          </button>
        );
      })}
    </div>
  );
}
